/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Gl_9_TInputs */

const en_tut_gl_9_t = /** @type {(inputs: Tut_Gl_9_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virtual office`)
};

const id_tut_gl_9_t = /** @type {(inputs: Tut_Gl_9_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kantor virtual`)
};

/**
* | output |
* | --- |
* | "Virtual office" |
*
* @param {Tut_Gl_9_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_gl_9_t = /** @type {((inputs?: Tut_Gl_9_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Gl_9_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_gl_9_t(inputs)
	return en_tut_gl_9_t(inputs)
});